import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CrudPageComponent } from './crud-page/crud-page.component';
import { FormPrintComponent } from './form-print/form-print.component';
import { BasicTableComponent } from './basic-table/basic-table.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PrimeNgModule } from 'src/app/demo/shared/prime-ng/prime-ng.module';
import { FormSendEmailComponent } from './form-send-email/form-send-email.component';
import { DialogFormDynamicComponent } from './dialog-form-dynamic/dialog-form-dynamic.component';
import { FooterPageComponent } from './footer-page/footer-page.component';
import { NavbarPageComponent } from './navbar-page/navbar-page.component';
import { RouteIndicatorComponent } from './route-indicator/route-indicator.component';
import { TitlePagesComponent } from './title-pages/title-pages.component';
import { MessageContainerLoadingComponent } from './message-container-loading/message-container-loading.component';
import { ValidityComponent } from './validity/validity.component';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { DialogValidityComponent } from './dialog-validity/dialog-validity.component';
import { ButtonsGroupDependecyComponent } from './buttons-group-dependecy/buttons-group-dependecy.component';
import { TruncatePipe } from 'src/app/demo/pipes/truncate.pipe';
import { RadioButtonModule } from 'primeng/radiobutton';
import { BotonSvgComponent } from './boton-svg/boton-svg.component';
import { TableroInformativoComponent } from './tablero-informativo/tablero-informativo.component';
import { AccordionModule } from 'primeng/accordion';
import { DialogFormDynamicTwoComponent } from './dialog-form-dynamic-two/dialog-form-dynamic-two.component';
import { BasicTableTwoComponent } from './basic-table-two/basic-table-two.component';
import { TableroInformativoTwoComponent } from './tablero-informativo-two/tablero-informativo-two.component';
import { FormPrintTwoComponent } from './form-print-two/form-print-two.component';
import { InputSwitchModule } from 'primeng/inputswitch';
import { SidePanelComponent } from './side-panel/side-panel.component';
import { SideCompressedComponent } from './side-compressed/side-compressed.component';
import { SidebarOneComponent } from './sidebar-one/sidebar-one.component';
import { FormMesaAyudaComponent } from './form-mesa-ayuda/form-mesa-ayuda.component';
import { InputGroupModule } from 'primeng/inputgroup';
import { DialogFormDynamicThreeComponent } from './dialog-form-dynamic-three/dialog-form-dynamic-three.component';
import { DialogFormDynamicFourComponent } from './dialog-form-dynamic-four/dialog-form-dynamic-four.component';
import { FormatQuestionPipe } from './basic-table-two/pipes/format-question.pipe';
import { TreeGenericOneComponent } from './tree-generic-one/tree-generic-one.component';
import { ColumnasCascadaComponent } from './columnas-cascada/columnas-cascada.component';

@NgModule({
  declarations: [
    CrudPageComponent,
    FormPrintComponent,
    FormPrintTwoComponent,
    BasicTableComponent,
    BasicTableTwoComponent,
    FormSendEmailComponent,
    DialogFormDynamicComponent,
    DialogFormDynamicTwoComponent,
    DialogFormDynamicThreeComponent,
    DialogFormDynamicFourComponent,
    FooterPageComponent,
    NavbarPageComponent,
    RouteIndicatorComponent,
    TitlePagesComponent,
    MessageContainerLoadingComponent,
    ValidityComponent,
    DialogValidityComponent,
    ButtonsGroupDependecyComponent,
    BotonSvgComponent,
    TruncatePipe,
    TableroInformativoComponent,
    TableroInformativoTwoComponent,
    SidePanelComponent,
    SideCompressedComponent,
    SidebarOneComponent,
    FormMesaAyudaComponent,
    FormatQuestionPipe,
    TreeGenericOneComponent,
    ColumnasCascadaComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    PrimeNgModule,
    OverlayPanelModule,
    RadioButtonModule,
    AccordionModule,
    InputSwitchModule,
    InputGroupModule,
  ],
  exports: [
    CrudPageComponent,
    FormPrintComponent,
    FormPrintTwoComponent,
    BasicTableComponent,
    BasicTableTwoComponent,
    FormSendEmailComponent,
    FooterPageComponent,
    NavbarPageComponent,
    RouteIndicatorComponent,
    TitlePagesComponent,
    MessageContainerLoadingComponent,
    ButtonsGroupDependecyComponent,
    BotonSvgComponent,
    TableroInformativoComponent,
    TableroInformativoTwoComponent,
    SidePanelComponent,
    SideCompressedComponent,
    SidebarOneComponent,
    FormMesaAyudaComponent,
    TreeGenericOneComponent,
    ColumnasCascadaComponent
  ]
})
export class SharedModule { }
